/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterN = createReactComponent("square-letter-n", "IconSquareLetterN", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 16v-8l4 8v-8", key: "svg-1" }]
]);

export { IconSquareLetterN as default };
//# sourceMappingURL=IconSquareLetterN.js.map
